import script from "./TheMainView.vue?vue&type=script&setup=true&lang=js"
export * from "./TheMainView.vue?vue&type=script&setup=true&lang=js"

import "./TheMainView.vue?vue&type=style&index=0&id=0c407cce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c407cce"]])

export default __exports__